<template>
	<div :class="containerClasses">
		<div :class="inline ? 'd-flex align-items-center' : ''">
			<div v-if="label" :class="mergedLabelClasses">
				<slot name="label-prefix"/> <span v-html="label" />
				<span v-if="labelTooltip" v-b-tooltip :title="labelTooltip" class="ml-2">
					<Icon icon="info" />
				</span>
			</div>
			<div v-if="!feedbackBeneath && !inline && state === false && invalidFeedback" class="error mb-2">{{ invalidFeedback }}</div>
			<slot />
		</div>
		<div v-if="description" class="mt-1 font-size-small font-italic">{{ description }}</div>
		<div v-if="(feedbackBeneath || inline) && state === false && invalidFeedback" class="error mt-2">{{ invalidFeedback }}</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon"

export default {

	components: {
		Icon,
	},

	props: {
		label: {
			type: String,
			required: false,
		},
		labelClasses: {
			type: Array,
			required: false,
			default: () => [],
		},
		labelTooltip: {
			type: String,
			required: false,
		},
		state: {
			type: Boolean,
			required: false,
		},
		invalidFeedback: {
			type: String,
			required: false,
		},
		feedbackBeneath: {
			type: Boolean,
			required: false,
			default: false,
		},
		inline: {
			type: Boolean,
			required: false,
			default: false,
		},
		fenced: {
			type: Boolean,
			required: false,
			default: false,
		},
		addInvalidClass: {
			type: Boolean,
			required: false,
			default: true,
		},
		noMargin: {
			type: Boolean,
			required: false,
			default: true,
		},
		description: {
			type: String,
			required: false,
		},
	},

	computed: {
		containerClasses ()
		{
			let classes = ['form-group'];

			if (this.addInvalidClass && this.state === false)
			{
				classes.push('is-invalid');
			}

			if (this.noMargin)
			{
				classes.push('m-0');
			}

			if (this.fenced)
			{
				classes.push('fenced');
			}

			return classes;
		},
		mergedLabelClasses ()
		{
			const classes = this.labelClasses;

			classes.push('label');

			if (!this.inline)
			{
				classes.push('mb-2');
			}

			if (this.inline)
			{
				classes.push('mr-2');
			}

			return classes;
		}
	}
}
</script>
